module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"help":"Help Center","features":"Features onboarding"},"id":{"help":"Pusat Bantuan","features":"Fitur onboarding"}}')
  delete Component.options._Ctor
}
